import { Skeleton } from '@avanta/shared/components/ui/Skeleton';

export const RecordNumberSkeleton = (): React.ReactElement => (
  <div
    className="flex items-center gap-4 rounded-xl bg-mint-100 px-6 py-4 mb-4"
    role="status"
    aria-busy="true"
    aria-live="polite"
  >
    <Skeleton className="size-10 shrink-0 rounded-md" />
    <div className="flex flex-col gap-1">
      <Skeleton className="h-4 w-48" />
      <Skeleton className="h-5 w-36" />
    </div>
  </div>
);
